import { Lock, ShieldCheck, Sparkles, Truck } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";

const VALUES = [
  {
    icon: Sparkles,
    title: "Carefully Selected Products",
    desc: "Every item is rigorously tested for durability, utility, and a modern design aesthetic before it earns a place in our catalogue.",
  },
  {
    icon: ShieldCheck,
    title: "Quality You Can Trust",
    desc: "Premium materials sourced directly from verified manufacturers — with zero compromises and full quality checks.",
  },
  {
    icon: Lock,
    title: "Secure Payments",
    desc: "100% encrypted checkout with UPI, cards, net banking, EMI, and Cash on Delivery options.",
  },
  {
    icon: Truck,
    title: "Fast & Reliable Delivery",
    desc: "Express shipping across India within 2–6 days, with real-time tracking on every single order.",
  },
];

export default function WhyUs() {
  return (
    <section data-testid="why-us-section" className="border-y border-neutral-200/70 bg-background">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-24 lg:px-8">
        <SectionHeading
          index="03"
          overline="The Everyday Standard"
          title="Why Choose Everyday Essentials"
          sub="Four promises we make on every order — no fine print."
        />
        <div className="grid grid-cols-1 gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-4">
          {VALUES.map((v, i) => (
            <Reveal key={v.title} delay={i * 0.09} className="group">
              <div className="border-t-2 border-neutral-900 pt-6">
                <div className="flex items-start justify-between">
                  <span className="font-serif text-5xl italic leading-none text-neutral-200 transition-colors duration-500 group-hover:text-neutral-900">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <v.icon size={22} strokeWidth={1.6} className="mt-1 text-neutral-900" />
                </div>
                <h3 className="mt-6 font-heading text-lg font-bold tracking-tight text-neutral-900">{v.title}</h3>
                <p className="mt-2.5 text-sm leading-relaxed text-neutral-500">{v.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
